// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","main":"Layout_main__T84kS","footer":"Layout_footer__1I3yD","footerTitle":"Layout_footerTitle__qYOMj","footerText":"Layout_footerText__BeJMG"};